module.exports = __webpack_public_path__ + "img/21.f1873a43.jpg";